"use client"
import { useSearchParams } from "next/navigation";
import { useCallback } from "react";

export function useQueryParams() {
    const searchParams = useSearchParams()
    const createQueryString = useCallback(
        (name: string, value: string[] | string | number | number []) => {
          const params = new URLSearchParams(searchParams.toString())
          params.delete("page")
          if (typeof value == "string" || typeof value == "number") {
            params.set(name, value?.toString());
          } else {
            params.delete(name)
            value.forEach(priceRange => params.append(name, priceRange?.toString()));
          }
          return params.toString()
        },
        [searchParams]
    )
    
    const deleteQueryString = useCallback(
      (name: string | string []) => {
        const params = new URLSearchParams(searchParams.toString())
        if(Array.isArray(name)){
          name?.forEach(el => params.delete(el))
        }else{
          params.delete(name)
        }
  
        return params.toString()
      },
      [searchParams]
    )
    const params = new URLSearchParams(searchParams.toString())
    return {
        createQueryString,
        deleteQueryString,
        searchParams: params.toString(),
        searchParamsObject: searchParams
    }
}